@if(content) {
<div class="flex flex-justify-center">
    <div class="p-a-2 col-11 b-a b-col-5 b-radius-4 flex flex-middle">
        <i class="icon-small m-r-1"
           [ngClass]="content.icon"></i>
        <p class="c1"
           *iCms="'text' of content; content: 'html'"></p>
    </div>
</div>
}